import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M2.57 9.43C2.57 4.22 6.79 0 12 0s9.43 4.22 9.43 9.43H2.57ZM24 12.86c0-1.6-3.43-1.71-12-1.71s-12 .11-12 1.71c0 1.6 6.86 1.4 6.86 3s-4.29.97-4.29 2.57c0 1.6 6 .97 6 2.57 0 .8-2.57 1.29-2.57 2.14 0 .8 1.71.86 6 .86s6-.06 6-.86c0-.86-2.57-1.34-2.57-2.14 0-1.6 6-.97 6-2.57 0-1.6-4.29-.97-4.29-2.57 0-1.6 6.86-1.4 6.86-3Z" />
  </>
);

const CollLakes = Icon('coll-lakes', svgContents);

export default CollLakes;
